<template>
    <v-card class="card-container">
        <v-card-title class="py-0">
            <v-row>
                <v-col cols="auto">
                    <v-btn
                            dense
                            color="var(--color-blue)"
                            @click="showAddModal"
                            dark
                    >
                        <span class="btn-text"><v-icon dark>add</v-icon> Добавить филиал</span>
                    </v-btn>
                </v-col>
                <v-col cols="4">
                    <v-text-field
                            class="search-block"
                            v-model="search"
                            prepend-inner-icon="mdi-magnify"
                            single-line
                            solo
                            placeholder="Поиск филиала"
                            dense
                            hide-details
                    />
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text class="h-100 p-0" style="overflow-y: scroll">
            <v-container fluid class="h-100">
                <v-data-table
                        :loading="loading"
                        :search="search"
                        no-data-text="Нет элементов"
                        no-results-text="Не найдено элементов"
                        loading-text="Загрузка данных"
                        calculate-widths
                        :items-per-page="filteredItems.length"
                        :items="filteredItems"
                        :headers="fields"
                        height="100%"
                        hide-default-footer
                        class="elevation-1 h-100"
                >
                    <template v-slot:item.phone="{item}">
                        <span v-for="phone in item.phones">{{ phone.phoneNumber }}<br></span>
                    </template>

                    <template v-slot:item.partnerTypes="{item}">
                        <template v-for="(type, ind) in item.partnerTypes">
                            <span>{{ type.partnerType }}</span><span
                                v-if="item.partnerTypes.length>0&&ind<item.partnerTypes.length-1"> • </span>
                        </template>
                    </template>

                    <template v-slot:item.edit="{item}">
                        <v-btn icon @click="showEditModal(item)">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>

            </v-container>

        </v-card-text>

        <addModal :show="showAdd" :organizationItem="item" @close="closeAdd"></addModal>
        <editModal :show="showEdit" :item="selectedBranch" @close="closeEdit"></editModal>
    </v-card>
</template>

<script>
    import addModal from '../dictionaries/PartnerBranches/AddNewBranchModal.vue'
    import editModal from '../dictionaries/PartnerBranches/EditBranchModal.vue'
    export default {
        name: "PartnerInfoBranches",
        props:["item"],
        components:{addModal, editModal},
        data(){
            return{
                loading:false,
                search:null,
                showAdd:false,
                selectedBranch:null,
                showEdit:false,
                fields: [
                    {value: "address", text: "Адрес"},
                    {value: "city", text: "Город", width:150},
                    {value: "phone", text: "Телефон", width:150},
                    {value: "partnerTypes", text: "Категории услуг"},
                    {value: "edit", text: "", width:50},

                ],
            }
        },
        computed:{
            filteredItems() {
                var items = this.$store.state.Partners.partnerBranches;
                if (items != null) {
                    return items
                }
                else return [];
            },
        },
        methods:{
            showAddModal(){
                this.showAdd=true
            },
            showEditModal(item){
                this.selectedBranch=item
                this.showEdit=true
            },
            closeAdd(isSave){
                this.showAdd=false;
                if(isSave==true){
                    const vm=this;
                    this.loading=true
                    this.$store.dispatch("Partners/getPartnerBranches", this.item.id).then(x=>vm.loading=false).catch((err) => {
                        console.log(err)
                        this.loading=false;
                        this.$bvToast.toast(err.message, {
                            title: `Ошибка загрузки списка партнеров!`,
                            variant: "danger",
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 3000,
                            solid: true
                        })
                    });
                }
            },
            closeEdit(isSave) {
                this.showEdit = false;
                if (isSave == true) {
                    const vm = this;
                    this.loading = true
                    this.$store.dispatch("Partners/getPartnerBranches", this.item.id).then(x => vm.loading = false).catch((err) => {
                        console.log(err)
                        this.loading = false;
                        this.$bvToast.toast(err.message, {
                            title: `Ошибка загрузки списка партнеров!`,
                            variant: "danger",
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 3000,
                            solid: true
                        })
                    });
                }
            }
        },
        mounted(){
            const vm=this;
            this.loading=true
            this.$store.dispatch("Partners/getPartnerBranches", this.item.id).then(x=>vm.loading=false).catch((err) => {
                console.log(err)
                this.loading=false;
                this.$bvToast.toast(err.message, {
                    title: `Ошибка загрузки списка партнеров!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            });

            if (this.$store.state.PartnerTypes.items.length == 0) {
                this.$store.dispatch("PartnerTypes/loadPartnerTypes").then(()=> {
                    vm.selectedTypes = []
                    vm.$store.state.PartnerTypes.items.forEach(item => {
                        vm.selectedTypes.push(item.id)
                    })
                }).catch((err) => {
                    console.log(err)
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки списка типов партнеров!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                });
            }
        }
    }
</script>

<style scoped>

</style>